import { NotFoundCard } from '../components';

function NotFoundPage(): JSX.Element {
  return <NotFoundCard />;
}

export default NotFoundPage;
